"use client";
import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

type ActiveFiltersProps = {
  filters: {
    category: string[];
    type: string[];
  };
  filteredCount: number;
  onClear: (name: "category" | "type", value?: string) => void;
  className?: string;
  countsByCategory?: Record<string, number>;
  countsByType?: Record<string, number>;
};

const ActiveFilters: React.FC<ActiveFiltersProps> = ({
  filters,
  filteredCount,
  onClear,
  className,
  countsByCategory,
  countsByType,
}) => {
  const categoryWithCount = (Array.isArray(filters.category) ? filters.category : []).filter(
    (cat) => (countsByCategory?.[cat] ?? 0) > 0
  );
  const typeWithCount = (Array.isArray(filters.type) ? filters.type : []).filter(
    (t) => (countsByType?.[t] ?? 0) > 0
  );
  const hasAny = categoryWithCount.length > 0 || typeWithCount.length > 0;
  if (!hasAny) return null;

  return (
    <div className={"flex flex-wrap gap-3 " + (className ?? "")}>
      {categoryWithCount.map((cat) => (
        <span key={"cat-" + cat} className="inline-flex items-center gap-2 rounded-md bg-white px-3 py-1 whitespace-nowrap text-sm text-gray-800">
          <span className="font-medium">
            {cat} ({countsByCategory?.[cat] ?? filteredCount})
          </span>
          <button
            type="button"
            onClick={() => onClear("category", cat)}
            className="text-gray-600 hover:text-gray-900"
            aria-label={`Clear ${cat} category filter`}
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </span>
      ))}
      {typeWithCount.map((t) => (
        <span key={"type-" + t} className="inline-flex items-center gap-2 rounded-md bg-white px-3 py-1 text-sm text-gray-800">
          <span className="font-medium">
            {t} ({countsByType?.[t] ?? filteredCount})
          </span>
          <button
            type="button"
            onClick={() => onClear("type", t)}
            className="text-gray-600 hover:text-gray-900"
            aria-label={`Clear ${t} type filter`}
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </span>
      ))}
    </div>
  );
};

export default ActiveFilters;
